function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['react', 'cookie', 'hola_opt', '/util/etask.js', '/util/url.js', '/www/hola/pub/common_util.js', '/www/hola/pub/util.js', '/www/hola/pub/install_util.js', '/svc/account/pub/membership.js', '/util/util.js', '/www/hola/pub/app_checker.js', '/util/fetch.js', '/util/storage.js'], (React, cookie, hopt, etask, zurl, common_util, www_util, iutil, membership, zutil, app_checker, fetch, storage) => {
  var E = {};
  E.App_context = React.createContext();
  E.Provider = class App_context_provider extends React.PureComponent {
    constructor(props) {
      super(props);
      _defineProperty(this, "state", {
        is_client: false,
        has_ext: false,
        has_svc: false,
        is_portal: false,
        env_label: null,
        user: null,
        member: undefined,
        inited: false,
        timeout_mistmach: 0,
        block_portal_detection: false
      });
      _defineProperty(this, "update_user", () => {
        if (this.props.user) return;
        var _this = this;
        return etask(function* () {
          var _yield$www_util$get_u = yield www_util.get_user(),
            user = _yield$www_util$get_u.user;
          if (user) _this.setState({
            user
          });
        });
      });
      _defineProperty(this, "update_user_embed", () => {
        var _this = this;
        return etask(function* () {
          var _yield$www_util$get_u2 = yield www_util.get_user(),
            user = _yield$www_util$get_u2.user;
          _this.setState({
            user
          });
        });
      });
      _defineProperty(this, "save_user", user => {
        window.hola_user = user && Object.assign({
          email: zutil.get(user, 'emails.0.value')
        }, zutil.pick(user, 'hola_uid', 'displayName'));
      });
      _defineProperty(this, "update_member", (opt = {}) => {
        if (this.props.member !== undefined && !opt.force) return;
        var _this = this;
        return etask(function* () {
          var member = yield www_util.get_membership();
          if (member) {
            var is_plus = membership.is_active(member);
            var is_ultra = membership.is_ultra(member);
            _this.setState({
              member,
              is_plus,
              is_ultra
            });
          }
        });
      });
      _defineProperty(this, "update_has_ext", () => {
        var _this$be;
        if (!this.be) return;
        var ext_info = (_this$be = this.be) === null || _this$be === void 0 ? void 0 : _this$be.ext();
        this.setState({
          has_ext: !!ext_info,
          has_opened_popup: ext_info && ext_info.has_opened_popup
        });
        var ext_cookie;
        try {
          ext_cookie = cookie.get('ext_ver');
          var cookie_opt = {
            domain: '.hola.org',
            path: '/'
          };
          if (ext_info && !ext_cookie) cookie.set('ext_ver', ext_info.ver, cookie_opt);
          if (!ext_info && ext_cookie) cookie.remove('ext_ver', cookie_opt);
        } catch (e) {
          console.log('cookie error', e);
        }
        var has_ext = !!ext_info;
        var user_data = this.state.user;
        if (user_data && user_data.displayName && user_data.displayName.familyName) {
          var emails = user_data.emails || [];
          var email = emails[0] && emails[0].value || '';
          var t_name = (user_data.name || '').trim();
          var d_name = t_name || email;
          var old_d_name = user_data.displayName;
          user_data.displayName = d_name;
          user_data.name = old_d_name;
        }
        var is_portal = common_util.is_portal({
          ua: navigator.userAgent,
          has_ext,
          user: user_data,
          www_hola: hopt.www_hola,
          query: zurl.qs_parse_url(location.href, {
            safe: true
          }),
          path: location.pathname
        });
        if (storage.get('install_ext_from_banner') && has_ext) {
          www_util.perr({
            id: 'www_peer_banner_ext_installed'
          });
          storage.clr('install_ext_from_banner');
        }
        if (!this.state.block_portal_detection && is_portal != this.state.is_portal) {
          if (!this.state.timeout_mistmach) {
            var _this = this;
            var timeout_mistmach = setTimeout(() => {
              www_util.perr({
                id: 'www_homepage_mismatch',
                info: {
                  is_portal,
                  ext_cookie,
                  ext_info
                }
              });
              _this.setState({
                is_portal,
                timeout_mistmach: 0
              });
            }, 3000);
            this.setState({
              timeout_mistmach
            });
          }
        } else {
          clearTimeout(this.state.timeout_mistmach);
          this.setState({
            timeout_mistmach: 0
          });
        }
      });
      _defineProperty(this, "set_svc_info", (has_svc, svc_info) => {
        this.setState({
          has_svc,
          svc_info
        });
      });
      _defineProperty(this, "update_svc_info", (opt = {}) => {
        if (!opt.force && !this.state.has_svc) return;
        var _this = this;
        var data = app_checker.get('svc_info') || {};
        var sync_token = data.sync_token;
        var old_appid = data.appid;
        var old_split_tunnel = zutil.get(data, 'full_vpn_capabilities.split_tunnel');
        return etask(function* () {
          yield app_checker._check_svc();
          var new_data = app_checker.get('svc_info') || {};
          if (new_data.appid) storage.set('unblock.svc.detected_ts', Date.now());
          var new_sync_token = new_data.sync_token;
          if (sync_token != new_sync_token) {
            if (new_sync_token && !_this.state.user) {
              _this.update_user();
              _this.update_member();
            }
            if (!new_sync_token && _this.state.user) {
              yield fetch('/users/logout/inline', {
                method: 'POST',
                credentials: 'include'
              });
              location.reload();
            }
          }
          if (opt.force || new_data && new_data.appid != old_appid || !zutil.equal_deep(zutil.get(new_data, 'full_vpn_capabilities.split_tunnel'), old_split_tunnel)) {
            storage.set_json('unblock.svc.info', new_data);
            _this.setState({
              svc_info: new_data,
              has_svc: new_data && !new_data.err
            });
          }
        });
      });
      _defineProperty(this, "update_has_svc", () => {
        var _this = this;
        return etask(function* () {
          var data = yield iutil.get_app_data();
          var _ref = data || {},
            is_installed_svc = _ref.is_installed_svc;
          var svc_info = app_checker.get('svc_info') || {};
          _this.setState({
            has_svc: !!is_installed_svc,
            svc_info
          });
        });
      });
      this.be = props.be;
      this.state.host = props.host;
      this.state.has_ext = props.has_ext;
      this.state.has_svc = props.has_svc;
      this.state.user = props.user;
      this.state.member = props.member;
      this.state.is_plus = membership.is_active(props.member);
      this.state.is_ultra = membership.is_ultra(props.member);
      this.state.is_portal = props.is_portal;
      this.state.env_label = props.env_label;
      this.state.headless = props.headless;
      this.state.headlogo = props.headlogo;
      this.state.footless = props.footless;
      this.state.block_portal_detection = props.block_portal_detection;
      this.state.svc_info = {};
      if (props.is_client_debug) this.state.is_client = true;
    }
    componentDidMount() {
      this.save_user(this.state.user);
      if (this.be) {
        this.be.on('change:ext.info', this.update_has_ext);
        this.be.on('change:user', this.update_user);
      }
      window.addEventListener('session_changed', this.update_user_embed);
      // XXX dmitriiz: use mouseover in safari when we'll fix commuticaton
      // questions with http
      document.addEventListener('mouseenter', this.update_svc_info);
      var _this = this;
      etask(function* () {
        _this.update_has_ext();
        yield _this.update_member();
        yield _this.update_has_svc();
        if (_this.props.force_update_user) yield _this.update_user();
        _this.setState({
          inited: true
        });
      });
      this.setState({
        is_client: true,
        update_svc_info: this.update_svc_info,
        set_svc_info: this.set_svc_info
      });
    }
    componentWillUnmount() {
      if (this.be) {
        this.be.off('change:ext.info', this.update_has_ext);
        this.be.off('change:user', this.update_user);
      }
      document.removeEventListener('mouseenter', this.update_svc_info);
      window.removeEventListener('session_changed', this.update_user_embed);
    }
    componentDidUpdate(prev_props, prev_state) {
      if (this.state.user !== prev_state.user) {
        this.save_user(this.state.user);
        this.update_member({
          force: true
        });
      }
    }
    render() {
      return /*#__PURE__*/React.createElement(E.App_context.Provider, {
        value: this.state
      }, this.props.children);
    }
  };
  return E;
});